import { Box, Card, CardContent, Container, useMediaQuery } from '@mui/material'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import BrandLogo from '@/components/BrandLogo'

const AccountPageShell = ({ children }) => {
    const smUp = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    return (
        <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 7.5 } }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mb: { xs: 4, sm: 8 }
                }}
            >
                <Box
                    component={RouterLink}
                    to="/"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        width: '100%',
                        maxWidth: { xs: 350, sm: 500 }
                    }}
                >
                    <BrandLogo height={smUp ? 110 : 70} />
                </Box>
            </Box>

            <Card>
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 4
                    }}
                >
                    {children}
                </CardContent>
            </Card>
        </Container>
    )
}

AccountPageShell.propTypes = {
    children: PropTypes.node.isRequired
}

export default AccountPageShell
